/* A job's "today" (Duncan 2026-10-20: "in the schedule tab we need to be able to change today's date for
   testing"). A test job can carry a test date (project.test_today, set on its Schedule tab) and
   everything on that job then runs as of it -- the Gantt's today line, how much progress a task can
   take, billing dates, the performance view, its reports. Mirrors server/projectToday.js. */
import { createContext, useContext } from 'react';

const DAY_RE = /^20\d{2}-\d{2}-\d{2}$/; // 2000-2099: a half-typed year (0002-03-15) is no test date

/** The job's test date ('YYYY-MM-DD'), or null: a real job, or no test date set. */
export const testDateOf = (project) => (project && project.is_test && DAY_RE.test(String(project.test_today || ''))
  ? project.test_today : null);

/** "Now" for the job: noon on its test date (so local-date math lands on that day), else the real now. */
export const nowOn = (testDate) => (testDate ? new Date(`${testDate}T12:00:00`) : new Date());

/** 'Mar 15, 2027' for a 'YYYY-MM-DD' day. */
export const fmtTestDate = (ymd) => nowOn(ymd).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });

/* The open job's { testDate, isTest, setTestDate(ymd | null) }, provided by the project page. Outside a
   job (or before it loads): no test date, and nothing to set. */
export const ProjectTodayContext = createContext({ testDate: null, isTest: false, setTestDate: null });
export const useProjectToday = () => useContext(ProjectTodayContext);
